<template>
  <footer id="footer">
    <div class="footer-border">
      <table class="footer-inside" border="0" >
        <tr>
          <td class="td-row1-col0"></td>
          <td class="td-row1-col1">
            <img src="../../assets/images/logo.png" style="background-color:transparent;" height="40px" width="100px" >
          </td>
          <td style="width:50px">
          </td>
          <td id="td-row1-col2">
            QUICK LINKS
          </td>
          <td id="td-row1-col3">
            SOCIAL
          </td>
          <td rowspan="3" id="td-row1-col4"></td>
        </tr>

        <tr>
          <td id="td-row2-col0"></td>
          <td id="td-row2-col1" rowspan=1 class="g-pad-b-2-lines">
            eHealth Engagement, LLC. is a team of Medical Directors, Physicians, Medical Associates, and Technologists that work together every day to provide medical program administration and wellness health delivery auditing to corporate workforces in the continental United States.
            <br><br>
            Copyright 2024, "All Rights Reserved"<br><br>
            version: {{ version }}
            
          </td>
          <td>
          </td>
          <td id="td-row2-col2">
            <table border="0">
              <tr>
                <td height="40px" >
                  <router-link to="/" class="linkStyle">Home</router-link>
                </td>
              </tr>
              
              <tr>
                <td height="40px" >
                  <router-link to="/contact" class="linkStyle">Contact</router-link>
                </td>
              </tr>
              <tr>
                <td height="40px">
                  <router-link to="/privacy-policy" class="linkStyle">Privacy Policy</router-link>
                </td>
              </tr>
              <tr>
                <td height="40px">
                  <router-link to="/terms-of-service" class="linkStyle">Terms of Service</router-link>
                </td>
              </tr>
              <tr>
                <td height="40px">
                  <router-link to="/news" class="linkStyle">Newsroom</router-link>
                </td>
              </tr>
            </table>
          </td>
          <td id="td-row2-col3">
            <table border="0" >
              <tr>
                <td height="40px">
                  <a href="https://www.facebook.com/EHealthEngagement/" class="linkStyle">Facebook</a>
                </td>
              </tr>
              
              <tr>
                <td height="40px">
                  <a href="https://www.linkedin.com/company/ehealthengagement/about/?viewAsMember=true" class="linkStyle">Linked-In</a>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      
        <tr>
          <td class="td-row1-col0"></td>
          <td colspan="3">
            <br>
            <div class="td-footer-col1">
              <img src="../../assets/images/idp_cert2.jpg" style="background-color:transparent;text-align:left;" height="160px" width="160px" />
            </div>
            <div class="td-footer-col1">
              <img src="../../assets/images/flcc2.jpg" style="background-color:transparent;text-align:left;" height="160px" width="160px" />
            </div>
            <div class="td-footer-col1">
              <img src="../../assets/images/aba.jpg" style="background-color:transparent;text-align:left;" height="160px" width="160px" />
            </div>
          </td>
        </tr>
        
      </table>
    </div>
  </footer>
</template>

<script>

export default {
    name: 'FooterView',
    mounted(){
      /* var scale = 'scale(1)';
        document.body.style.webkitTransform =  scale;    // Chrome, Opera, Safari
        document.body.style.msTransform =   scale;       // IE 9
        document.body.style.transform = scale;     // General */
    },
    data() { 
      return { 
          version: process.env.VUE_APP_VERSION,  
      }
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global.css";

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  a {
    color: #473F44;
    font-weight: 400;
  }

  // BEGIN FOOTER STYLES
  #footer
  { 
    position: relative;    
    bottom: 0;
    font-family:Lato;
    font-size:.9em;
    font-weight: 300;
    width:100% !important;
    min-width:100% !important;
    color:white;
    background-color:silver;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left:0px;
    padding-right:0px;
    margin-left: 0px;
  }
  .footer-border
  {
    padding:0px;
  }
  .footer-inside
  {
    width:100% !important;
    min-width:100% !important;
    height:40px; 
    background-color:silver; 
  }  
  // END FOOTER STYLES

  // BEGIN TABLE STYLES
  // ROW 1, COLUMN  1 - SPACE
  .td-row1-col0
  {
    min-width: 5px;
    width:5px;
  }
  .td-row1-col1 // LOGO
  {
    color:black;
    font-family: Lato;
    font-size:13px; 
    font-weight: 300; 
    text-align:left;
    padding-right:10px;
    min-width: 100%;
    width:100%;
    height:75px;
    vertical-align: middle;
  }
  .td-footer-col1
  {
    /*color:black;
    font-family: Lato;
    font-size:13px; 
    font-weight: 300; 
    text-align:left;
    padding-right:10px;
    min-width: 100%;
    width:100%;
    height:75px;
    vertical-align: middle;*/
    //float:;
  }
  // ROW 1, COLUMN 2
  #td-row1-col2 // QUICK LINKS
  {
    color:black;
    font-family: Lato;
    font-size:13px;  
    font-weight: bold;
    min-width: 100%;
    width:100%;
    height:0px;
    vertical-align: middle;
    visibility: hidden;
  }
  // ROW 1, COLUMN  3
  #td-row1-col3 // SOCIAL
  {
    color:black;
    font-family: Lato;
    font-size:13px;  
    font-weight: bold;
    text-align:left;
    padding-right:0px; //10px;
    min-width: 100%;
    width:100%;
    height:0px;
    vertical-align: middle;
    visibility: hidden;
  }
  // ROW 1, COLUMN 4
  #td-row1-col4 // SPACE
  {
    //min-width:5%;
    background-position: right;
  }
  /////////////////////////////
  // ROW 2, COLUMN  1
  #td-row2-col0 // SPACE
  {
    /* min-width: 5px;
    width:5px; */
    color:black;
  }
  #td-row2-col1 // DISCLAIMER
  {
    color:black;
    font-family: Lato;
    font-size:13px;  
    font-weight: 300;
    text-align:justify;
    padding-right:5px;
    padding-left:5px;
    padding-top:0px;
    width:100%;
    min-width:100%;
    vertical-align:top;   
    //border-spacing: 10px 5px;
  }
  // ROW 2, COLUMN 2
  #td-row2-col2 // QUICK LINKS
  { 
    color:black;
    background-color:rgb(70,130,180);
    font-family: Lato;
    font-size:13px;  
    font-weight: 300;
    text-align:left;
    width:100%;
    min-width:100%;
    vertical-align: top;
  }
  // ROW 2, COLUMN  3
  #td-row2-col3 // SOCIAL LINKS
  {
    color:white;
    background-color:#473F44;
    font-family: Lato;
    font-weight: 300;
    font-size:13px;  
    text-align:right;
    padding-right:10px;
    width:100%;
    min-width:100%;
    vertical-align: top;
    margin-left: 0px;
  }
  // END TABLE STYLES

  // BEGIN FONT STYLES
  .linkStyle
  {
    color:white;
    padding-left:5px
  }
  // END FONT STYLES
}


//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px) 
{
    a {
    color: #473F44;
    font-weight: 400;
  }

  // BEGIN FOOTER STYLES
  #footer
  { 
    position: relative;    
    bottom: 0;
    font-family:Lato;
    font-size:.9em;
    font-weight: 300;
    width:100%;
    color: #473F44;
    background-color:silver;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left:0px;
    padding-right:0px;
    margin: 0px;
  }
  .footer-border
  {
    padding:5px;
  }
  .footer-inside
  {
    width:100%;
    height:50px; 
    background-color:silver; ;//#D6DBDF;//slategray;
  }  
  // END FOOTER STYLES

  // BEGIN TABLE STYLES
  // ROW 1, COLUMN  1 - SPACE
  .td-row1-col0
  {
    min-width: 50px;
    width:5%;
  }
  .td-row1-col1 // LOGO
  {
    color:#473F44;
    font-family: Lato;
    font-size:13px;  
    font-weight: 300;
    text-align:left;
    padding-right:10px;
    min-width: 100px;
    width:30%;
    height:75px;
    vertical-align: middle;
  }
  .td-footer-col1{
    float: left;
    padding-left: 10px;
    padding-right: 10px;
  }
  // ROW 1, COLUMN 2
  #td-row1-col2 // QUICK LINKS
  {
    color:#473F44;
    font-family: Lato;
    font-size:13px;  
    font-weight: bold;
    min-width: 100px;
    width:30%;
    vertical-align: middle;
  }
  // ROW 1, COLUMN  3
  #td-row1-col3 // SOCIAL
  {
    color:#473F44;
    font-family: Lato;
    font-size:13px;  
    font-weight: bold;
    text-align:left;
    padding-right:10px;
    min-width: 100px;
    width:30%;
    vertical-align: middle;
  }
  // ROW 1, COLUMN 4
  #td-row1-col4 // SPACE
  {
    min-width:5%;
    background-position: right;
  }
  /////////////////////////////
  // ROW 2, COLUMN  1
  #td-row2-col0 // SPACE
  {
    min-width: 50px;
    width:5%;
  }
  #td-row2-col1 // DISCLAIMER
  {
    color:#473F44;
    font-family: Lato;
    font-size:13px;  
    font-weight: 500;
    text-align:justify;
    padding-right:10px;
    width:9%;
    vertical-align: top;   
    border-spacing: 10px 5px;
  }
  // ROW 2, COLUMN 2
  #td-row2-col2 // QUICK LINKS
  { 
    color:#473F44;
    font-family: Lato;
    font-size:13px;  
    text-align:left;
    font-weight:bold;
    width:16%;
    vertical-align: top;
  }
  // ROW 2, COLUMN  3
  #td-row2-col3 // SOCIAL LINKS
  {
    color:#473F44;
    font-family: Lato;
    font-size:13px;  
    font-weight: bold;
    text-align:right;
    padding-right:10px;
    width:10%;
    vertical-align: top;
  }
  // END TABLE STYLES

  // BEGIN FONT STYLES
  .linkStyle
  {
    color:black;
    padding-left:5px
  }
  // END FONT STYLES
}
</style>